import React from "react";

import { runValidator } from "../../../forms/validation";
import { ILocation } from "../../../models/location";
import { isZipLocation } from "../../../utils/guards";
import { useAppDispatch, useAppSelector } from "../../reducers";
import { updateEnteredLocation } from "../reducers";
import { preferredLocationSelector } from "../selectors";

import styles from "./EditablePostalCode.module.scss";

const getInitialVal = (currentLocation: ILocation | null): string => {
    const initialVal =
        currentLocation && isZipLocation(currentLocation)
            ? currentLocation.zip
            : currentLocation?.formatted_address;
    return initialVal || "";
};

export const EditablePostalCode = (props: {
    isReadOnly?: boolean;
    className?: string;
}): React.ReactNode => {
    const [isFocused, setIsFocused] = React.useState(false);
    const [value, setValue] = React.useState("");
    const inputElem = React.useRef<HTMLInputElement>(null);

    const currentLocation = useAppSelector((state) =>
        preferredLocationSelector(state),
    );
    const dispatch = useAppDispatch();

    const isEditing = isFocused && !props.isReadOnly;
    const displayValue = isEditing ? value : getInitialVal(currentLocation);

    const onFocus = () => {
        setIsFocused(true);
        setValue(getInitialVal(currentLocation));
    };

    const onBlur = () => {
        const errMsg = runValidator("zipcode", value);
        if (!errMsg) {
            dispatch(
                updateEnteredLocation({
                    formatted_address: value,
                    zip: value,
                }),
            );
        }
        setIsFocused(false);
    };

    const onChange = (e: React.FormEvent<HTMLInputElement>) => {
        setValue(e.currentTarget.value);
    };

    const classes = props.className
        ? props.className
        : `${styles.input} al-predicted-delivery-date__zip-code`;

    return (
        <span className={styles.inputWrapper}>
            <label htmlFor={"editable-postal-code"} aria-hidden={true}>
                {displayValue}
            </label>
            <input
                id={"editable-postal-code"}
                ref={inputElem}
                className={classes}
                value={displayValue}
                disabled={props.isReadOnly}
                autoComplete="postal-code"
                // TODO(i18n): Use t tagged template for placeholder: placeholder={t`ZIP`}
                placeholder={"ZIP"}
                onFocus={onFocus}
                onBlur={onBlur}
                onChange={onChange}
            />
        </span>
    );
};
